import './style.scss';
import MessageSection, {MessageSectionProps} from "@able/react/dist/MessageSection";
import Column from "@able/react/dist/Column";
import Surface from "@able/react/dist/Surface";
import TextStyle from "@able/react/dist/TextStyle";
import Grid from "@able/react/dist/Grid";
import Spacing from "@able/react/dist/Spacing";
import Lozenge, {LozengeProps}  from '@able/react/dist/Lozenge';

import { useDocumentTitle } from '../util';

const MATERIAL_BASE_PRIMARY = "materialBasePrimary";
const MATERIAL_BASE_SECONDARY = "materialBaseSecondary";

type pageHeadingProps = { pageHeading: string };
type callOutProps = { Callout: string } & pageHeadingProps;

export type SiteNameProp = {
    siteName?: string;
}

export type PageHeadingSimpleProps = {
  SurfaceVariant: typeof MATERIAL_BASE_PRIMARY | typeof MATERIAL_BASE_SECONDARY;
  headingType: "Default" | "Callout";
  headingDescription?: string | React.ReactNode;
  messageSection: boolean;
  lozengeSection?: LozengeProps;
} & SiteNameProp &
  pageHeadingProps &
  Partial<callOutProps> &
  Partial<MessageSectionProps>;

const PageHeadingCallout = (props: callOutProps) => {
    return (
        <hgroup role="group" aria-roledescription="Heading group">
            <TextStyle alias="HeadingC" alignment="Left" element="h1">
                {props.pageHeading}
            </TextStyle>
            <TextStyle className="tui-page-heading-simple-callout" alias="HeadingA" alignment="Left" element="p">
                {props.Callout}
            </TextStyle>
        </hgroup>
    );
};

const PageHeadingDefault = (props: pageHeadingProps) => {
    return (
        <TextStyle alias="HeadingA" alignment="Left" element="h1">
            {props.pageHeading}
        </TextStyle>
    );
};

const PageHeadingSimple = (props: PageHeadingSimpleProps) => {
    const {
        SurfaceVariant,
        pageHeading,
        headingType,
        Callout,
        headingDescription,
        messageSection,
        lozengeSection,
        siteName
    } = props;

    useDocumentTitle(pageHeading, siteName);

    return (
        <Surface
            background={SurfaceVariant}
            cornerRadius="cornerRadiusNone"
            interactive={false}
            variant="SurfaceFlat"
        >
            <Spacing
                topVXS="spacing2x"
                bottomVXS="spacing4x"
                topVSM="spacing3x"
                bottomVSM="spacing5x"
                topVMD="spacing4x"
                bottomVMD="spacing7x"
                topVLG="spacing5x"
                bottomVLG="spacing7x"
            >
                <Grid>
                    <Column cols={12} bsm={12} bmd={8} blg={8}>
                        {headingType === "Callout" ? (
                            <PageHeadingCallout Callout={Callout as string} pageHeading={pageHeading} />
                        ) : (
                            <PageHeadingDefault pageHeading={pageHeading} />
                        )}

                        {headingDescription && (
                            <p className="tui-page-heading-simple-description">{headingDescription}</p>
                        )}
                        {lozengeSection && 
                        <>
                            <Spacing
                                topVXS="spacing1x"
                                topVSM="spacing1x"
                                topVMD="spacing1x"
                                topVLG="spacing1nHalf"
                            />
                            <Lozenge {...lozengeSection} />
                        </>}
                        {messageSection && (
                            <>
                                <Spacing
                                    topVXS="spacing3x"
                                    topVSM="spacing3x"
                                    topVMD="spacing4x"
                                    topVLG="spacing4x"
                                >
                                    <Column cols={12} bsm={12} bmd={8} blg={8}>
                                        <MessageSection {...props as MessageSectionProps} />
                                    </Column>
                                </Spacing>
                            </>
                        )}
                    </Column>
                </Grid>
            </Spacing>
        </Surface>
    );
};

export default PageHeadingSimple;
